import type { StockTableView } from '../types/stockTableView.types';

const STORAGE_KEY = 'poc-app-stock-table-custom-views-v1';

export const loadCustomStockTableViews = (): StockTableView[] => {
  if (typeof window === 'undefined') {
    return [];
  }

  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);

    if (!raw) {
      return [];
    }

    const parsed = JSON.parse(raw) as unknown;

    if (!Array.isArray(parsed)) {
      return [];
    }

    return parsed.filter(
      (item): item is StockTableView =>
        typeof item === 'object' &&
        item !== null &&
        typeof (item as StockTableView).id === 'string' &&
        typeof (item as StockTableView).label === 'string' &&
        typeof (item as StockTableView).state === 'object',
    );
  } catch {
    return [];
  }
};

export const saveCustomStockTableViews = (views: StockTableView[]): void => {
  if (typeof window === 'undefined') {
    return;
  }

  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(views));
};
